export var currentActiveVideo = reactive({
  currentVideo: '',
  setCurrentVideo: function setCurrentVideo(videoName) {
    this.currentVideo = videoName;
  }
});